/**
 * Replanification d'une tâche (drag calendrier, popover échéance).
 * Règle : une due_datetime garde son HEURE locale, seul le jour change ;
 * une due_date reste une date simple. Pur, testé.
 */

export function mergeDueDate(
  task: { due_date: string | null; due_datetime: string | null },
  isoDay: string,
): { due_date?: string | null; due_datetime?: string | null } {
  const [y, m, d] = isoDay.split('-').map(Number);
  if (task.due_datetime) {
    const old = new Date(task.due_datetime);
    if (!Number.isNaN(old.getTime())) {
      const merged = new Date(y!, m! - 1, d!, old.getHours(), old.getMinutes());
      return task.due_date
        ? { due_date: isoDay, due_datetime: merged.toISOString() }
        : { due_datetime: merged.toISOString() };
    }
  }
  return { due_date: isoDay };
}

export function clearDue(): { due_date: null; due_datetime: null } {
  return { due_date: null, due_datetime: null };
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function extractDueTime(dueDatetime: string | null): string {
  if (!dueDatetime) return '';
  const d = new Date(dueDatetime);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function extractDueDay(task: {
  due_date: string | null;
  due_datetime: string | null;
}): string {
  if (task.due_date) return task.due_date.slice(0, 10);
  if (task.due_datetime) {
    const d = new Date(task.due_datetime);
    if (!Number.isNaN(d.getTime())) {
      return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    }
  }
  return '';
}

/** Pose ou retire l’heure. Sans heure → date seule (journée entière au calendrier). */
export function mergeDueTime(
  _task: { due_date: string | null; due_datetime: string | null },
  isoDay: string,
  hhmm: string | null,
): { due_date: string | null; due_datetime: string | null } {
  if (!hhmm) {
    return { due_date: isoDay, due_datetime: null };
  }
  const [h, m] = hhmm.split(':').map(Number);
  const [y, mo, d] = isoDay.split('-').map(Number);
  const dt = new Date(y!, mo! - 1, d!, h ?? 0, m ?? 0);
  return { due_date: isoDay, due_datetime: dt.toISOString() };
}
